import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export let form =
{
	model: 'ShowPosition'.toLowerCase(),
	name: 'ShowPosition'.toLowerCase(),
	pattern: 'ShowPosition'.toLowerCase(),

	form_title: 'Placement',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer ce placement',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce placement&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['showposition[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau placement <strong> { model.label } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/placements/' + model.id }>
						Voir la page du placement
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model         : 'ShowPosition'.toLowerCase(),
	title         : 'Liste des placements',
	link          : '/configuration/placements',
	creation_link : '/configuration/nouveau-placement',
	creation_label: 'Nouveau placement',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/placements/',
	searched_prop: 'label'
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config;